export default __webpack_public_path__ + "static/java-learn-coding-689c0ce14053f033af0ee02e603fbe35.webp";